module.exports = __webpack_public_path__ + "img/vinkje-icon-blauw.731a8b17660c3acf56481cb82b9d6e50.svg";